import React, { useEffect, useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon, UserPlusIcon, MoreHorizontalIcon, CheckCircleIcon, XCircleIcon, XIcon, AlertCircleIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
const Toast = ({
  message,
  type,
  onClose
}: {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  return <div className={`fixed top-20 right-8 z-50 flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg text-white animate-fadeIn ${type === 'success' ? 'bg-green-600' : 'bg-red-600'}`} data-id="element-2257">
      {type === 'success' ? <CheckCircleIcon size={20} data-id="element-2258" /> : <AlertCircleIcon size={20} data-id="element-2259" />}
      <span className="font-medium text-sm" data-id="element-2260">{message}</span>
      <button onClick={onClose} className="ml-4 hover:opacity-80" data-id="element-2261">
        <XIcon size={16} data-id="element-2262" />
      </button>
    </div>;
};
const PeopleManager = () => {
  const [activeTab, setActiveTab] = useState('admissions');
  const [searchQuery, setSearchQuery] = useState('');
  const [toast, setToast] = useState<{
    message: string;
    type: 'success' | 'error';
  } | null>(null);
  // Modals
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{
    type: 'approve' | 'reject';
    app: any;
  } | null>(null);
  const showToast = (message: string, type: 'success' | 'error' = 'success') => {
    setToast({
      message,
      type
    });
  };
  // Mock Data States
  const [admissions, setAdmissions] = useState([{
    id: 'APP-2026-001',
    name: 'Oluwaseun Adebayo',
    grade: 'JSS 1',
    date: 'Feb 20, 2026',
    status: 'pending',
    score: '85%'
  }, {
    id: 'APP-2026-002',
    name: 'Chioma Nnamdi',
    grade: 'SS 1',
    date: 'Feb 19, 2026',
    status: 'approved',
    score: '92%'
  }, {
    id: 'APP-2026-003',
    name: 'Ibrahim Musa',
    grade: 'JSS 1',
    date: 'Feb 18, 2026',
    status: 'pending',
    score: '78%'
  }, {
    id: 'APP-2026-004',
    name: 'Grace Olatunji',
    grade: 'JSS 2',
    date: 'Feb 15, 2026',
    status: 'rejected',
    score: '45%'
  }, {
    id: 'APP-2026-005',
    name: 'David Peters',
    grade: 'SS 1',
    date: 'Feb 14, 2026',
    status: 'approved',
    score: '88%'
  }]);
  const [students, setStudents] = useState([{
    id: 'STU-001',
    name: 'Adeola Johnson',
    class: 'SS 3 Science',
    house: 'Ransome-Kuti',
    enrolled: 'Sep 2020',
    status: 'Active'
  }, {
    id: 'STU-002',
    name: 'Chukwudi Eze',
    class: 'SS 2 Art',
    house: 'Awolowo',
    enrolled: 'Sep 2021',
    status: 'Active'
  }, {
    id: 'STU-003',
    name: 'Fatima Bello',
    class: 'JSS 3',
    house: 'Azikiwe',
    enrolled: 'Sep 2023',
    status: 'Active'
  }, {
    id: 'STU-004',
    name: 'Samuel Ojo',
    class: 'SS 1 Commercial',
    house: 'Bello',
    enrolled: 'Sep 2022',
    status: 'Suspended'
  }]);
  const [staff, setStaff] = useState([{
    id: 'STF-001',
    name: 'Dr. O. A. Adeyemi',
    dept: 'Administration',
    role: 'Principal',
    qual: 'Ph.D Education',
    phone: '08012345678'
  }, {
    id: 'STF-002',
    name: 'Mrs. F. T. Ojo',
    dept: 'Sciences',
    role: 'HOD Science',
    qual: 'M.Sc Physics',
    phone: '08023456789'
  }, {
    id: 'STF-003',
    name: 'Mr. K. L. Bakare',
    dept: 'Arts',
    role: 'English Teacher',
    qual: 'B.A English',
    phone: '08034567890'
  }, {
    id: 'STF-004',
    name: 'Miss E. N. Okon',
    dept: 'Mathematics',
    role: 'Math Teacher',
    qual: 'B.Sc Mathematics',
    phone: '08045678901'
  }]);
  const [alumni, setAlumni] = useState([{
    id: 'ALU-001',
    name: 'Prof. Tunde Otubu',
    year: '1975',
    occupation: 'University Professor',
    location: 'Lagos, Nigeria',
    email: 'totubu@example.com'
  }, {
    id: 'ALU-002',
    name: 'Engr. Segun Awolowo',
    year: '1982',
    occupation: 'Civil Engineer',
    location: 'London, UK',
    email: 'segun.a@example.com'
  }, {
    id: 'ALU-003',
    name: 'Dr. Amina Mohammed',
    year: '1990',
    occupation: 'Medical Doctor',
    location: 'Abuja, Nigeria',
    email: 'amina.m@example.com'
  }, {
    id: 'ALU-004',
    name: 'Chief Bayo Ojo',
    year: '1968',
    occupation: 'Business Executive',
    location: 'Ibadan, Nigeria',
    email: 'b.ojo@example.com'
  }]);
  const tabs = [{
    id: 'admissions',
    label: 'Admissions (New)'
  }, {
    id: 'students',
    label: 'Students'
  }, {
    id: 'staff',
    label: 'Staff Directory'
  }, {
    id: 'alumni',
    label: 'Alumni Registry'
  }];
  const handleExport = () => {
    showToast(`Exporting ${activeTab} data to CSV...`);
    setTimeout(() => {
      showToast(`${activeTab} data exported successfully!`);
    }, 1500);
  };
  const handleAdmissionAction = (type: 'approve' | 'reject', app: any) => {
    setCurrentAction({
      type,
      app
    });
    setIsActionModalOpen(true);
  };
  const confirmAdmissionAction = () => {
    if (currentAction) {
      setAdmissions(admissions.map(a => a.id === currentAction.app.id ? {
        ...a,
        status: currentAction.type === 'approve' ? 'approved' : 'rejected'
      } : a));
      showToast(`Application ${currentAction.type === 'approve' ? 'approved' : 'rejected'} successfully`);
      setIsActionModalOpen(false);
      setCurrentAction(null);
    }
  };
  const handleAddSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    showToast(`New ${activeTab.slice(0, -1)} added successfully`);
    setIsAddModalOpen(false);
  };
  // Filtering logic based on active tab
  const getFilteredData = () => {
    const query = searchQuery.toLowerCase();
    switch (activeTab) {
      case 'admissions':
        return admissions.filter(a => a.name.toLowerCase().includes(query) || a.id.toLowerCase().includes(query));
      case 'students':
        return students.filter(s => s.name.toLowerCase().includes(query) || s.class.toLowerCase().includes(query));
      case 'staff':
        return staff.filter(s => s.name.toLowerCase().includes(query) || s.dept.toLowerCase().includes(query));
      case 'alumni':
        return alumni.filter(a => a.name.toLowerCase().includes(query) || a.year.includes(query));
      default:
        return [];
    }
  };
  const filteredData = getFilteredData();
  return <div className="space-y-6 animate-fadeIn relative" data-id="element-2263">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} data-id="element-2264" />}

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2265">
        <div data-id="element-2266">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2267">
            People Management
          </h1>
          <p className="text-sm text-gray-500" data-id="element-2268">
            Manage students, staff, alumni, and admission applications.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-2269">
          <button onClick={handleExport} className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm transition-colors" data-id="element-2270">
            <DownloadIcon size={16} className="mr-2" data-id="element-2271" />
            Export CSV
          </button>
          <button onClick={() => setIsAddModalOpen(true)} className="inline-flex items-center px-4 py-2 bg-blue-950 text-yellow-400 rounded-lg text-sm font-medium hover:bg-blue-900 shadow-sm transition-colors" data-id="element-2272">
            <UserPlusIcon size={16} className="mr-2" data-id="element-2273" />
            Add New
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 overflow-x-auto" data-id="element-2274">
        {tabs.map(tab => <button key={tab.id} onClick={() => {
        setActiveTab(tab.id);
        setSearchQuery('');
      }} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === tab.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2275">
            {tab.label}
          </button>)}
      </div>

      {/* Filters & Search */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col sm:flex-row gap-4 justify-between items-center" data-id="element-2276">
        <div className="relative w-full sm:w-96" data-id="element-2277">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-2278" />
          <input type="text" placeholder={`Search ${activeTab}...`} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2279" />
        </div>
        <div className="flex gap-3 w-full sm:w-auto" data-id="element-2280">
          {activeTab === 'alumni' && <select className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white" data-id="element-2281">
              <option value="all" data-id="element-2282">All Years</option>
              <option value="1960s" data-id="element-2283">1960s</option>
              <option value="1970s" data-id="element-2284">1970s</option>
              <option value="1980s" data-id="element-2285">1980s</option>
              <option value="1990s" data-id="element-2286">1990s</option>
              <option value="2000s" data-id="element-2287">2000s</option>
            </select>}
          {activeTab === 'admissions' && <select className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white" data-id="element-2288">
              <option value="all" data-id="element-2289">All Status</option>
              <option value="pending" data-id="element-2290">Pending</option>
              <option value="approved" data-id="element-2291">Approved</option>
              <option value="rejected" data-id="element-2292">Rejected</option>
            </select>}
          <button className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center gap-2 bg-white" data-id="element-2293">
            <FilterIcon size={16} data-id="element-2294" />
            <span className="hidden sm:inline" data-id="element-2295">Filters</span>
          </button>
        </div>
      </div>

      {/* Content Area based on Tab */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-2296">
        <div className="overflow-x-auto" data-id="element-2297">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-2298">
            <thead className="bg-gray-50" data-id="element-2299">
              {activeTab === 'admissions' && <tr data-id="element-2300">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2301">
                    App ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2302">
                    Applicant Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2303">
                    Applying For
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2304">
                    Date Submitted
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2305">
                    Exam Score
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2306">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2307">
                    Actions
                  </th>
                </tr>}
              {activeTab === 'students' && <tr data-id="element-2308">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2309">
                    Student ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2310">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2311">
                    Class
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2312">
                    House
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2313">
                    Enrolled
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2314">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2315">
                    Actions
                  </th>
                </tr>}
              {activeTab === 'staff' && <tr data-id="element-2316">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2317">
                    Staff ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2318">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2319">
                    Department
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2320">
                    Role
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2321">
                    Contact
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2322">
                    Actions
                  </th>
                </tr>}
              {activeTab === 'alumni' && <tr data-id="element-2323">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2324">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2325">
                    Class Of
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2326">
                    Occupation
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2327">
                    Location
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2328">
                    Contact
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2329">
                    Actions
                  </th>
                </tr>}
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2330">
              {filteredData.length === 0 ? <tr data-id="element-2331">
                  <td colSpan={7} className="px-6 py-12 text-center text-gray-500" data-id="element-2332">
                    No records found matching your search.
                  </td>
                </tr> : filteredData.map((item: any) => <tr key={item.id} className="hover:bg-gray-50 transition-colors" data-id="element-2333">
                    {activeTab === 'admissions' && <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-2334">
                          {item.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2335">
                          {item.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2336">
                          {item.grade}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2337">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700" data-id="element-2338">
                          {item.score}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2339">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${item.status === 'approved' ? 'bg-green-100 text-green-800' : item.status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2340">
                            {item.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2341">
                          <div className="flex items-center justify-end gap-2" data-id="element-2342">
                            {item.status === 'pending' && <>
                                <button onClick={() => handleAdmissionAction('approve', item)} className="p-1.5 text-green-600 hover:bg-green-50 rounded transition-colors" title="Approve" data-id="element-2343">
                                  <CheckCircleIcon size={18} data-id="element-2344" />
                                </button>
                                <button onClick={() => handleAdmissionAction('reject', item)} className="p-1.5 text-red-600 hover:bg-red-50 rounded transition-colors" title="Reject" data-id="element-2345">
                                  <XCircleIcon size={18} data-id="element-2346" />
                                </button>
                              </>}
                            <button className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors" title="More options" data-id="element-2347">
                              <MoreHorizontalIcon size={18} data-id="element-2348" />
                            </button>
                          </div>
                        </td>
                      </>}
                    {activeTab === 'students' && <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500" data-id="element-2349">
                          {item.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2350">
                          {item.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2351">
                          {item.class}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2352">
                          {item.house}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2353">
                          {item.enrolled}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2354">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-2355">
                            {item.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2356">
                          <button className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors" data-id="element-2357">
                            <MoreHorizontalIcon size={18} data-id="element-2358" />
                          </button>
                        </td>
                      </>}
                    {activeTab === 'staff' && <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500" data-id="element-2359">
                          {item.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2360">
                          {item.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2361">
                          {item.dept}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2362">
                          <div data-id="element-2363">{item.role}</div>
                          <div className="text-xs text-gray-400" data-id="element-2364">
                            {item.qual}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 flex items-center gap-1" data-id="element-2365">
                          <PhoneIcon size={14} className="text-gray-400" data-id="element-2366" />{' '}
                          {item.phone}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2367">
                          <button className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors" data-id="element-2368">
                            <MoreHorizontalIcon size={18} data-id="element-2369" />
                          </button>
                        </td>
                      </>}
                    {activeTab === 'alumni' && <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2370">
                          {item.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-blue-600" data-id="element-2371">
                          {item.year}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2372">
                          {item.occupation}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 flex items-center gap-1" data-id="element-2373">
                          <MapPinIcon size={14} className="text-gray-400" data-id="element-2374" />{' '}
                          {item.location}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2375">
                          <div className="flex items-center gap-1" data-id="element-2376">
                            <MailIcon size={14} className="text-gray-400" data-id="element-2377" />{' '}
                            {item.email}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2378">
                          <button className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors" data-id="element-2379">
                            <MoreHorizontalIcon size={18} data-id="element-2380" />
                          </button>
                        </td>
                      </>}
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Action Confirmation Modal */}
      {isActionModalOpen && currentAction && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn" data-id="element-2381">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-2382">
            <div className="p-6 text-center" data-id="element-2383">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${currentAction.type === 'approve' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-2384">
                {currentAction.type === 'approve' ? <CheckCircleIcon size={24} className="text-green-600" data-id="element-2385" /> : <XCircleIcon size={24} className="text-red-600" data-id="element-2386" />}
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2 capitalize" data-id="element-2387">
                {currentAction.type} Application?
              </h2>
              <p className="text-gray-500 mb-6" data-id="element-2388">
                Are you sure you want to {currentAction.type} the admission
                application for <strong data-id="element-2389">{currentAction.app.name}</strong>?
              </p>
              <div className="flex gap-3 justify-center" data-id="element-2390">
                <button onClick={() => setIsActionModalOpen(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors flex-1" data-id="element-2391">
                  Cancel
                </button>
                <button onClick={confirmAdmissionAction} className={`px-4 py-2 text-white rounded-lg text-sm font-medium transition-colors flex-1 ${currentAction.type === 'approve' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}`} data-id="element-2392">
                  Yes, {currentAction.type}
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Add New Modal */}
      {isAddModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn" data-id="element-2393">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-2394">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-2395">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2396">
                Add New {activeTab.slice(0, -1)}
              </h2>
              <button onClick={() => setIsAddModalOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2397">
                <XIcon size={24} data-id="element-2398" />
              </button>
            </div>
            <div className="p-6" data-id="element-2399">
              <form id="add-form" onSubmit={handleAddSubmit} className="space-y-4" data-id="element-2400">
                <div data-id="element-2401">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2402">
                    Full Name *
                  </label>
                  <input type="text" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-2403" />
                </div>
                <div data-id="element-2404">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2405">
                    Email Address
                  </label>
                  <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-2406" />
                </div>
                <div data-id="element-2407">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2408">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-2409" />
                </div>
              </form>
            </div>
            <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end gap-3" data-id="element-2410">
              <button onClick={() => setIsAddModalOpen(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors" data-id="element-2411">
                Cancel
              </button>
              <button form="add-form" type="submit" className="px-4 py-2 bg-blue-950 text-yellow-400 rounded-lg text-sm font-medium hover:bg-blue-900 transition-colors" data-id="element-2412">
                Save Record
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default PeopleManager;